module.exports = __webpack_public_path__ + "media/images/icons/notification-dd85f2b23609ffe727b3738207c81055.png";